import React from 'react';

export default function Radio({ name, value, label, binding, handleChange, children }) {
    return (
        <label className='block my-3'>
            <input
                type="radio"
                name={name}
                value={value}
                className='mr-1'
                checked={value == binding}
                onChange={e => handleChange(e)}
            />
            {children}
        </label>
    );
}
